import React from "react";
import { User } from "../../constant/imgages";
const UserAvatar = () => {
  return (
    <div className="h-8 w-8 rounded-full cursor-pointer hover:ring-1 transition-all duration-150 ease-linear ring-sky-400 hover:p-0.5">
      <img src={User} className="h-full w-full rounded-full object-cover" />
    </div>
  );
};

export default UserAvatar;
